var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4972 4.62704L18.5 6.75V15H17.5V4.25C17.5 3.00736 16.4926 2 15.25 2H6.25C5.00736 2 4 3.00736 4 4.25V8.37889C3.39701 8.78252 3 9.4699 3 10.25V18.75C3 20.5449 4.45507 22 6.25 22H8.61682C8.66272 22.0028 8.70899 22.0042 8.75559 22.0042H15.25C15.3176 22.0042 15.3849 22.0028 15.4518 22H17.75C19.5449 22 21 20.5449 21 18.75V17.25C21 16.4699 20.603 15.7825 20 15.3789V6.75C20 5.76929 19.3726 4.93512 18.4972 4.62704ZM5.5 8V4.25C5.5 3.83579 5.83579 3.5 6.25 3.5H15.25C15.6642 3.5 16 3.83579 16 4.25V15H15.9041C15.6956 15 15.4964 14.9132 15.3545 14.7603L9.74468 8.71899C9.31895 8.26051 8.72155 8 8.0959 8H5.5ZM4.5 10.25C4.5 9.83579 4.83579 9.5 5.25 9.5H8.0959C8.30445 9.5 8.50358 9.58684 8.64549 9.73966L14.2553 15.781C14.681 16.2395 15.2785 16.5 15.9041 16.5H18.75C19.1642 16.5 19.5 16.8358 19.5 17.25V18.75C19.5 19.7165 18.7165 20.5 17.75 20.5H6.25C5.2835 20.5 4.5 19.7165 4.5 18.75V10.25Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.af1776603a491eb9111ac2e38fb78d4c.svg";
export { ForwardRef as ReactComponent };